import React from 'react';
import { Link } from 'react-router-dom';

// Schlanker globaler Footer mit den drei Pflicht-Links (Impressum,
// Datenschutz, AGB). TMG §5 verlangt, dass das Impressum von jeder
// Seite aus zu erreichen ist -- deshalb mounten wir den Footer im
// App-Root.
const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-gray-200 dark:border-slate-800 bg-white dark:bg-slate-950 mt-12 print:hidden dark:bg-slate-900/80 dark:border-slate-700">
      <div className="container mx-auto px-4 py-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-gray-500 dark:text-gray-400">
        <div className="text-center sm:text-left">
          © {year} PredFuture · Virtuelle Credits, keine echte Geldzahlung.
        </div>
        <nav className="flex items-center gap-4">
          <Link to="/impressum" className="hover:text-emerald-600 dark:hover:text-emerald-400">Impressum</Link>
          <Link to="/datenschutz" className="hover:text-emerald-600 dark:hover:text-emerald-400">Datenschutz</Link>
          <Link to="/agb" className="hover:text-emerald-600 dark:hover:text-emerald-400">AGB</Link>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
